const endpoints = {
	create: '/drafts/create',
	update: '/drafts/update',
	shareDraft: '/drafts/shareDraft',
	getDraftsByProjectID: '/drafts/getDraftsByProjectID',
	getDraftByID: '/drafts/getDraftByID',
	delete: '/drafts/delete',
	removeUserShared: '/drafts/removeUserShared',
}
export {endpoints}